<template>
  <v-card :loading="loading" outlined>
    <v-card-title>
      Questionário
      <v-btn @click="loadItems()" icon :disabled="loading">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        @click="handleClickGenerate()"
        color="primary"
        :disabled="loading || !enabled"
        :loading="generating"
        v-show="newItem === null"
      >
        Gerar
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-alert v-if="!enabled" type="warning" text border="left">
        A funcionalidade está bloqueada para essa companhia.
      </v-alert>
      <v-card v-if="newItem" color="primary" dark>
        <v-card-title>
          Link gerado
          <v-spacer></v-spacer>
          <v-btn @click="handleClickCloseNewItem()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="text-wrap">
          Copie e envie para o segurado, não será possível ver este link
          novamente
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            :value="newItem?.url"
            outlined
            dense
            readonly
            bg-color="red"
          >
            <template #append>
              <v-btn
                @click="handleClickCopyNewLink()"
                icon
                style="margin-top: -5px"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-menu offset-y>
            <template #activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" text :loading="sharing">
                <v-icon left>mdi-share-variant</v-icon>
                Partilhar
              </v-btn>
            </template>

            <v-list>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-account </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ newItem.participant.contact.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ newItem.participant.type.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                @click="
                  handleClickShareViaSms(
                    newItem,
                    newItem.participant.contact.contact1
                  )
                "
                v-if="newItem.participant.contact.contact1"
                link
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Contacto principal
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    SMS: {{ newItem.participant.contact.contact1 }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-share</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item
                @click="
                  handleClickShareViaSms(
                    newItem,
                    newItem.participant.contact.contact2
                  )
                "
                v-if="newItem.participant.contact.contact2"
                link
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Contacto secundário
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ newItem.participant.contact.contact2 }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-share</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item
                @click="
                  handleClickShareViaEmail(
                    newItem,
                    newItem.participant.contact.email
                  )
                "
                v-if="newItem.participant.contact.email"
                link
              >
                <v-list-item-content>
                  <v-list-item-subtitle> Email </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ newItem.participant.contact.email }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-share</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item
                v-if="
                  !newItem.participant.contact.contact1 &&
                  !newItem.participant.contact.contact2 &&
                  !newItem.participant.contact.email
                "
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Nenhum contacto telef atribuído ao participante
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
      </v-card>

      <v-simple-table>
        <thead>
          <tr>
            <th>Lesado</th>
            <th>Status</th>
            <th>Data de geração</th>
            <th>Responsável</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>
              {{ item.participant?.contact?.name }}
            </td>
            <td>
              {{
                item.is_finished
                  ? "Finalizado"
                  : item.is_expired
                  ? "Expirado"
                  : "Ativo"
              }}
            </td>
            <td>
              {{ formatDateTime(item.created_at) || "---" }}
            </td>
            <td>
              {{ item.user?.name }}
            </td>
            <td class="text-right">
              <v-btn @click="handleClickShow(item)" icon>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn @click="handleClickDelete(item.id)" icon>
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div v-if="items.length < 1 && !loading" class="text-center mt-4 mb-3">
        Nenhum questionário gerado
      </div>
    </v-card-text>

    <SimpleFnolDialog ref="dialog"></SimpleFnolDialog>
  </v-card>
</template>

<script>
import ToastsMixin from "@/mixins/ToastsMixin.vue";

import {
  indexByLead,
  storeForInsured,
  destroy,
  shareViaSms,
  shareViaEmail,
} from "@/services/simple_fnol_managers";
import { formatDateTime } from "@/tools/date";
import SimpleFnolDialog from "./SimpleFnolDialog.vue";

export default {
  mixins: [ToastsMixin],

  components: {
    SimpleFnolDialog,
  },

  props: {
    insured: Object,
  },

  data() {
    return {
      items: [],
      loading: false,
      formatDateTime,
      generating: false,
      newItem: null,
      sharing: false,
      enabled: true,
    };
  },

  methods: {
    async loadItems() {
      this.loading = true;
      try {
        this.items = [];
        const { data, meta } = await indexByLead(
          this.$route.params.lead_number
        );
        this.items = data;
        this.enabled = meta.enabled;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async handleClickGenerate() {
      this.generating = true;
      try {
        const response = await storeForInsured({
          lead_number: this.$route.params.lead_number,
        });
        this.newItem = response;
        this.loadItems();
      } catch (error) {
        console.error(error);
        if (error.response.status === 400) {
          this.toastError(error.response.data.message);
        }
      } finally {
        this.generating = false;
      }
    },

    handleClickCloseNewItem() {
      this.newItem = null;
    },

    handleClickCopyNewLink() {
      navigator.clipboard.writeText(this.newItem.url);
      this.toast("Copiado");
    },

    async handleClickDelete(id) {
      if (!confirm("Excluir questionário?")) return;

      await destroy(id);

      this.toast("Questionário removido");

      this.loadItems();
    },

    handleClickShow(simpleFnol) {
      this.$refs.dialog.open(simpleFnol);
    },

    async handleClickShareViaSms(simpleFnol, phoneNumber) {
      this.sharing = true;
      try {
        const response = await shareViaSms(simpleFnol.id, {
          phone_number: phoneNumber,
        });

        this.toast("Link enviado via SMS");
      } catch (error) {
        this.toastError("Falha ao enviar SMS");
      } finally {
        this.sharing = false;
      }
    },

    async handleClickShareViaEmail(simpleFnol, email) {
      this.sharing = true;
      try {
        const response = await shareViaEmail(simpleFnol.id, {
          email: email,
        });

        this.toast("Link enviado via email");
      } catch (error) {
        this.toastError("Falha ao enviar email");
      } finally {
        this.sharing = false;
      }
    },
  },

  computed: {},

  created() {
    this.loadItems();
  },
};
</script>
